import React from "react";
import { Box, Image } from "@chakra-ui/react";

export default function CSSAvatar({ user, size = "sm" }) {
  // Size mappings using scale factor like DefaultAvatar
  const sizeMap = {
    xs: 28,
    sm: 36,
    md: 48,
    lg: 80
  };

  const sizeNum = sizeMap[size] || sizeMap.sm;
  const scale = sizeNum / 36; // Base size is 36px (same as DefaultAvatar)

  return (
    <Box
      position="relative"
      w={`${sizeNum}px`}
      h={`${sizeNum}px`}
      borderRadius="50%"
      overflow="hidden"
      bg={user?.photo ? "transparent" : "white"}
      display="flex"
      alignItems="center"
      justifyContent="center"
      border={`${1.5 * scale}px solid`}
      borderColor="gray.400"
      flexShrink={0}
      _before={!user?.photo ? {
        content: '""',
        position: "absolute",
        top: `${8 * scale}px`,
        left: "50%",
        transform: "translateX(-50%)",
        w: `${12 * scale}px`,
        h: `${12 * scale}px`,
        borderRadius: "50%",
        border: `${2 * scale}px solid`,
        borderColor: "gray.900",
        bg: "white"
      } : {}}
      _after={!user?.photo ? {
        content: '""',
        position: "absolute",
        bottom: `${3 * scale}px`,
        left: "50%",
        transform: "translateX(-50%)",
        w: `${20 * scale}px`,
        h: `${14 * scale}px`,
        borderRadius: "50% 50% 0 0",
        border: `${2 * scale}px solid`,
        borderColor: "gray.900",
        borderBottom: "none",
        bg: "white"
      } : {}}
    >
      {user?.photo && (
        <Image
          src={user.photo}
          alt={user.displayName || user.name || ""}
          w="full"
          h="full"
          objectFit="cover"
        />
      )}
    </Box>
  );
}